const BottomOverlay = ({ gameData }) => {
  if (!gameData || !gameData.Venue) return null;

  const { logo, name } = gameData.Venue;

  return (
    <div className="font-exo-two absolute left-1/2 top-0 -translate-x-1/2 -translate-y-9">
      <div className="flex items-center gap-2 rounded bg-hockey-page-bg/60 pr-2 shadow-lg ring-1 ring-black/20">
        {logo ? (
          <img
            src={logo}
            alt={name}
            className="h-8 w-8 rounded-l object-contain"
            loading="lazy"
          />
        ) : null}
        <p className="text-sm font-light uppercase tracking-wide text-white">
          {name}
        </p>
      </div>
    </div>
  );
};

export default BottomOverlay;
